module.exports = __webpack_public_path__ + "img/drinks.09a2817.jpg";